import { JurisdictionAnalyticsPanel } from './JurisdictionAnalyticsPanel'
import { useJurisdictionAnalytics } from './useJurisdictionAnalytics'

/**
 * `/insights/dashboards/jurisdictions` (IB-282 View 3) — thin composition root wiring
 * `useJurisdictionAnalytics` (the real state) into `JurisdictionAnalyticsPanel` (the presentational
 * grid), mirroring `CaseAnalyticsContainer`'s own one-line wire-up shape (View-2 precedent) kept as
 * its own file so this route's own diff in `AppRouter.tsx` stays a one-line addition.
 */
export function JurisdictionAnalyticsContainer() {
  const analytics = useJurisdictionAnalytics()
  return <JurisdictionAnalyticsPanel {...analytics} />
}
